import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { Grid, TablePagination } from '@material-ui/core'
import PropTypes from 'prop-types'
import {
  fetchFavouriteArticles,
  updateFavoriteArticle,
} from 'routes/ArticlesDashboard/api'
import ArticleCard from 'routes/ArticlesDashboard/components/ArticleCard'
import { Translate } from 'react-localize-redux'
import NotFound from 'components/NotFound'
import { LoadingSpinner } from 'components'
import useStyles from 'routes/ArticlesDashboard/styles'

const ArticlesCarousel = ({ teamUuid }) => {
  const classes = useStyles()
  const [articles, setArticles] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(12)
  const [page, setPage] = useState(0)
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(true)

  const loadArticles = useCallback(() => {
    setLoading(true)
    fetchFavouriteArticles(teamUuid, {
      page: page + 1,
      per_page: rowsPerPage,
    })
      .then((response) => {
        setArticles(response.data)
        setMeta(response.meta)
      })
      .catch((err) => {
        console.error('Failed to fetch favourite articles', err)
        setArticles([])
        setMeta({})
      })
      .finally(() => {
        setLoading(false)
      })
  }, [teamUuid, page, rowsPerPage])

  useEffect(() => {
    loadArticles()
  }, [loadArticles])

  const handleFavoriteToggle = (article) => {
    updateFavoriteArticle(article.uuid, !article.favorite)
      .then(() => {
        loadArticles(page, rowsPerPage)
      })
      .catch((error) => {
        console.error('Error toggling favorite status:', error)
      })
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  return (
    <>
      <Grid item xs={12}>
        <TablePagination
          labelRowsPerPage={<Translate id="drills.rows-perpage" />}
          component="div"
          count={meta?.total ?? 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          className={classes.tablePagination}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[12, 24, 36]}
          SelectProps={{
            MenuProps: {
              PaperProps: { elevation: 0 },
            },
          }}
        />
      </Grid>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Grid container spacing={3}>
          {articles.length > 0 ? (
            articles.map((article) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={article.uuid}>
                <ArticleCard
                  article={article}
                  onFavoriteToggle={() => handleFavoriteToggle(article)}
                  showArticleActions={false}
                />
              </Grid>
            ))
          ) : (
            <NotFound />
          )}
        </Grid>
      )}
    </>
  )
}

ArticlesCarousel.propTypes = {
  teamUuid: PropTypes.string.isRequired,
}

export default connect(({ team }) => ({
  teamUuid: team.uuid,
}))(ArticlesCarousel)
